export { JiraTemplateChoiceUfoWrapper } from "./views/jira-template-choice/jira-choice-view-manager";
export { ConfirmationPageTemplate } from "./confirmation-page.template";
export { ConfirmationPageTemplate as default } from "./confirmation-page.template";
